import { CommonModule } from '@angular/common';
import { HttpBackend } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { ConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';

import { CustomRouteGuard } from '../../SGRE-shared/services/guard/msal.guard';

import { OrderDetailsService } from './services/order-details.service';
import { OrderDetailsEffectsService } from './store/effects/order-details-effect.service';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { CsvPDFbuttonsComponent } from './components/csv-pdfbuttons/csv-pdfbuttons.component';
import { DeliveryInformationComponent } from './components/delivery-information/delivery-information.component';
import { OrderDetailtableComponent } from './components/order-detailtable/order-detailtable.component';
import { OrderInformationComponent } from './components/order-information/order-information.component';
import { OrderTotalSummaryComponent } from './components/order-total-summary/order-total-summary.component';
import { RecreatecancelComponent } from './components/recreate-cancel/recreate-cancel.component';
import { customDefaultOccOrderDetailsConfig } from './config/default-occ-order-details-config';
import { OrderDetailsEffects } from './store/effects/order-details.effects';
import { ORDER_DETAILS_FEATURE } from './store/order-details.state';
import { customReducers } from './store/reducer';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    OrderDetailtableComponent,
    RecreatecancelComponent,
    CsvPDFbuttonsComponent,
    OrderInformationComponent,
    OrderTotalSummaryComponent,
    DeliveryInformationComponent
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    FormsModule,
    SGRESharedModule,
    DialogModule,
    ButtonModule,
    ReactiveFormsModule,
    StoreModule.forFeature(ORDER_DETAILS_FEATURE, customReducers),
    EffectsModule.forFeature(OrderDetailsEffects),
    ConfigModule.withConfig({
      cmsComponents: {
        OrderInformationComponent: {
          component: () => import('./components/order-information/order-information.component').then(m => m.OrderInformationComponent),
          guards: [CustomRouteGuard]
        },
        DeliveryInformationComponent: {
          component: () => import('./components/delivery-information/delivery-information.component').then(m => m.DeliveryInformationComponent),
          guards: [CustomRouteGuard]
        },
        RecreateAndCancelButtonComponent: {
          component: () => import('./components/recreate-cancel/recreate-cancel.component').then(m => m.RecreatecancelComponent),
          guards: [CustomRouteGuard]
        },
        OrderDetailsTableComponent: {
          component: () => import('./components/order-detailtable/order-detailtable.component').then(m => m.OrderDetailtableComponent),
          guards: [CustomRouteGuard]
        },
        DownloadCSVandPDFComponent: {
          component: () => import('./components/csv-pdfbuttons/csv-pdfbuttons.component').then(m => m.CsvPDFbuttonsComponent),
          guards: [CustomRouteGuard]
        },
        OrderTotalSummaryComponent: {
          component: () => import('./components/order-total-summary/order-total-summary.component').then(m => m.OrderTotalSummaryComponent),
          guards: [CustomRouteGuard]
        }
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule
  ],
  providers: [
    TranslateService,
    { provide: TranslateStore },
    provideConfig(customDefaultOccOrderDetailsConfig),
    OrderDetailsService,
    OrderDetailsEffectsService,
  ]
})
export class OrderDetailModule { }
